
import { Injectable } from '@angular/core';
import { StorageConstants } from '../constant/storage.constant';
import { DeviceLocalStorageData } from '../models/rest/user/device-local-storage-data.model';
import { LocalLogModel } from '../models/dto/local-log.model';
import { DateUtils } from '../utils/date.utils';
import { StringUtils } from '../utils/string.utils';
import { LogTypeEnum } from 'app/enum/log-type.enum';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }
  getString(key: string, defValue?: string) {
    let value = sessionStorage.getItem(key);
    return StringUtils.isEmpty(value) ? defValue : value;
  }
  setString(key: string, value: string | null | undefined) {
    if (StringUtils.isEmpty(value)) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value!);
    }
  }

  getNumber(key: string, defValue?: number) {
    let value = sessionStorage.getItem(key);
    return StringUtils.isEmpty(value) ? defValue : Number(value);
  }

  setNumber(key: string, value: number) {
    if (value == null) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value.toString());
    }
  }


  getBoolean(key: string, defValue?: boolean) {
    let value = sessionStorage.getItem(key);
    return StringUtils.isEmpty(value) ? defValue : Boolean(value);
  }

  setBoolean(key: string, value: boolean) {
    if (value == null) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value.toString());
    }
  }

  getJSONData(key: string) {
    let value = sessionStorage.getItem(key);
    if (value == null) {
      return null;
    }
    return JSON.parse(value);
  }
  setJSONData(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getDeviceStorageData() {

    let data = this.getJSONData(StorageConstants.DEVICE_LOCAL_STORAGE);
    if (data == null) {
      data = new DeviceLocalStorageData();
      this.setJSONData(StorageConstants.DEVICE_LOCAL_STORAGE, data);

    }
    return data;
  }

  setDeviceStorageData(data: DeviceLocalStorageData) {
    this.setJSONData(StorageConstants.DEVICE_LOCAL_STORAGE, data);
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }


  addLocalLog(logType: string, message?: string) {

    if (logType == LogTypeEnum.INFO) {
      return;
    }

    let dataJson = this.getJSONData(StorageConstants.LOCAL_LOG);

    let dataList: LocalLogModel[] = [];
    if (dataJson == null) {
      dataList = [];
    }
    else {
      dataList = dataJson;
    }

    let newLog: LocalLogModel = new LocalLogModel();
    newLog.logDate = DateUtils.getNow();
    newLog.logType = logType;
    newLog.message = message;

    if (dataList.length > 100)
      dataList.splice(0, 1);
    dataList.push(newLog);

    this.setJSONData(StorageConstants.LOCAL_LOG, dataList);
  }

}
